module.exports = "<div class=\"row\">\r\n \r\n</div>\r\n\r\n\r\n\r\n<p-tabView  >\r\n  <p-tabPanel header=\"Dashboard\" >\r\n    <app-dashboard></app-dashboard>\r\n  </p-tabPanel>\r\n  <p-tabPanel header=\"Reports\">\r\n  <ng-template pTemplate=\"content\">\r\n  <app-custom-reports></app-custom-reports>\r\n   </ng-template>\r\n  </p-tabPanel>\r\n  \r\n</p-tabView>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/reports-dashboard/reports-dashboard.component.html
// module id = ./src/app/admin/reports-dashboard/reports-dashboard.component.html
// module chunks = main